import { Either } from "fp-ts/lib/Either";
import ServiceEntity from "../entities/ServiceEntity";

abstract class ServiceRepository {
    abstract getServiceById(id: string): Promise<Either<string, ServiceEntity>>;
    abstract requestCarPickup(serviceId: string): Promise<Either<string, void>>;
    abstract acceptTermsAndConditions(serviceId: string): Promise<Either<string, void>>;
}

export default ServiceRepository;